export const USER_ATTRIBUTES_MOCK_RESPONSE = {
  data: {
    user: {
      name: 'portal',
      lastName: 'user',
      email: 'test@betterfly.com',
      holdings: [
        {
          id: 20,
          name: 'Yaneken',
          fullAccess: true,
          companies: [
            {
              id: '58',
              name: 'belsport',
              countryCode: 'cl',
              role: {
                name: 'affinity',
                permissions: [
                  'menu.collaborators.collaborators-detail',
                  'menu.metrics',
                  'menu',
                  'rewards',
                  'rewards.load-balance',
                  'rewards.points',
                  'rewards.history'
                ]
              }
            },
            {
              id: '16',
              name: 'test b2b',
              countryCode: 'br',
              role: {
                name: 'default',
                permissions: ['menu', 'support-form']
              }
            }
          ]
        },
        {
          id: 15,
          name: 'Betterfly',
          fullAccess: true,
          companies: [
            {
              id: '8',
              name: 'betterfly',
              countryCode: 'cl',
              externalId: '1',
              role: {
                name: 'affinity',
                permissions: ['menu.collaborators.collaborators-detail', 'menu.metrics', 'menu']
              }
            }
          ]
        }
      ],
      locale: 'es',
      hasLoggedIn: true,
      phone: {
        number: '123-456-7890'
      },
      image: 'https://i0.wp.com/iarc.dev/api/images/31b0da9e36a87a85e8172e8d57f3d9a5.jpg'
    }
  }
};

export const USER_DATA_MOCK = {
  name: 'portal user',
  email: 'test@betterfly.com',
  externalId: '1',
  holdings: [
    {
      id: 15,
      name: 'Betterfly',
      fullAccess: true,
      companies: [
        {
          id: 8,
          name: 'betterfly',
          countryCode: 'cl',
          role: {
            name: 'default',
            permissions: ['menu', 'support-form']
          }
        }
      ]
    },
    {
      id: 20,
      name: 'Yaneken',
      fullAccess: true,
      companies: [
        {
          id: 58,
          name: 'belsport',
          countryCode: 'cl',
          role: {
            name: 'default',
            permissions: ['menu', 'support-form']
          }
        },
        {
          id: 16,
          name: 'test b2b',
          countryCode: 'br',
          role: {
            name: 'default',
            permissions: ['menu', 'support-form']
          }
        }
      ]
    }
  ],
  locale: 'es'
};

export const USER_ATTRIBUTES_WITHOUT_NAME_MOCK_RESPONSE = {
  data: {
    user: {
      name: '',
      lastName: '',
      email: 'test@betterfly.com',
      holdings: [
        {
          id: 20,
          name: 'Yaneken',
          fullAccess: true,
          companies: [
            {
              id: 58,
              name: 'belsport',
              countryCode: 'cl',
              role: {
                name: 'default',
                permissions: ['menu', 'support-form']
              }
            },
            {
              id: 16,
              name: 'test b2b',
              countryCode: 'br',
              role: {
                name: 'affinity',
                permissions: ['menu.collaborators.collaborators-detail', 'menu.metrics', 'menu']
              }
            }
          ]
        },
        {
          id: 15,
          name: 'Betterfly',
          fullAccess: true,
          companies: [
            {
              id: 8,
              name: 'betterfly',
              countryCode: 'cl',
              role: {
                name: 'default',
                permissions: ['menu', 'support-form']
              }
            }
          ]
        }
      ],
      locale: 'pt'
    }
  }
};

export const USER_IMAGE_MOCK_RESPONSE = {
  data: {
    url: 'https://i.blogs.es/64df00/dragon-ball-este-es-el-diseno-original-de-goku-adulto-que-nunca-vimos-en-el-anime/1366_2000.jpeg'
  }
};

export const CHECK_EMAIL_MOCK_RESPONSE = {
  data: {
    verified: true
  }
};

export const INTERCOM_TOKEN_MOCK_RESPONSE = {
  data: {
    token: null
  }
};
